/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import AuthenticationSchemeList from 'app/developer-v3/pages/authentication/AuthenticationSchemeList';
import AuthenticationSchemePicker from 'app/developer-v3/pages/authentication/AuthenticationSchemePicker';
import { getAppVersionUrl } from 'app/developer-v3/utils';

import type { AuthenticationSchema } from 'app/developer-v3/platformSchema/authentication';
import type { VersionParams } from 'app/developer-v3/types/version';
import type { ClickHandler } from 'app/common/types';

const Styles = {
  root: css`
    height: 100%;
  `,
};

type Props = {
  authentication: AuthenticationSchema;
  isLegacy: boolean;
  isSaving: boolean;
  onDeleteAuthentication: ClickHandler;
  onSaveAuthenticationSchemeType: (type: string) => void;
  params: VersionParams;
};

const AuthenticationPage = (props: Props) => {
  const {
    authentication,
    isLegacy,
    isSaving,
    onDeleteAuthentication,
    onSaveAuthenticationSchemeType,
    params: { id, version },
  } = props;

  const authType = authentication?.type;

  return (
    <div css={Styles.root}>
      {authType && !isSaving ? (
        <AuthenticationSchemeList
          authType={authType}
          editUrl={`${getAppVersionUrl(id, version)}/authentication/edit`}
          isLegacy={isLegacy}
          onDeleteAuthentication={onDeleteAuthentication}
        />
      ) : (
        <AuthenticationSchemePicker
          isSaving={isSaving}
          onSaveAuthenticationSchemeType={onSaveAuthenticationSchemeType}
        />
      )}
    </div>
  );
};

export default AuthenticationPage;
